import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredPlayCircleFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g filter="url(#filter0_i_15069_274784)">
      <path
        d="M13.7263 7.53922L2.82065 1.07213C2.45576 0.86716 2 1.12346 2 1.53308V14.4669C2 14.8765 2.45576 15.1328 2.82065 14.9279L13.7263 8.46078C14.0912 8.2558 14.0912 7.74387 13.7263 7.53889V7.53922Z"
        fill="url(#paint0_linear_15069_274784)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_15069_274784"
        x={2}
        y={-1}
        width={12}
        height={16}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={-2} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_15069_274784"
        />
      </filter>
      <linearGradient
        id="paint0_linear_15069_274784"
        x1={11.7084}
        y1={15.5052}
        x2={4.50312}
        y2={4.82438}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A3FF" />
        <stop offset={1} stopColor="#83EAEC" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredPlayCircleFilled)
const IconSvgColouredPlayCircleFilled = createIcon(
  ForwardRef,
  'SvgColouredPlayCircleFilled',
)
export default IconSvgColouredPlayCircleFilled
